import { localized, msg } from "@lit/localize";
import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";
import "@whilecat/core/shoe.ts";

@localized()
@customElement("not-found")
export class NotFound extends LitElement {
    static styles = css`
    :host {
      display: block;
    }

    .notFound {
      display: flex;
      flex-wrap: wrap;
      margin-left: 5%;
      margin-right: 5%;
      justify-content: center;
    }

    .container {
      display: block;
      text-align: center;
    }

    .faded::after {
      box-shadow: inset 0 0 5px 15px var(--whilecat-background-color);
      content: "";
      display: block;
      height: 400px;
      position: absolute;
      top: 0;
      width: 450px;
    }
  `;

    render() {
        return html`
      <div>
        <sl-animation
          name="fadeIn"
          easing="ease"
          duration="2000"
          iterations="1"
          play
        >
          <div class="notFound">
            <div class="container">
              <div class="faded">
                <img src="/resources/404.webp" width="450" height="400" />
              </div>
              <h2>${msg("Check out our courses though")}</h2>
              <sl-button variant="primary" pill href="/courses">${msg("Find a course")}</sl-button>
            </div>
          </div>
        </sl-animation>
      </div>
    `;
    }
}
